const code = [
  { "label": "Czech Republic", "value": "420" },
  { "label": "Slovakia", "value": "421" },
  { "label": "Ukraine", "value": "380" },
  { "label": "Croatia", "value": "385" },
  { "label": "Slovenia", "value": "386" },
  { "label": "Netherlands", "value": "31" },
  { "label": "Hungary", "value": "36" },
  { "label": "Austria", "value": "43" },
  { "label": "United Kingdom", "value": "44" },
  { "label": "Poland", "value": "48" },
  { "label": "Germany", "value": "49" },
  { "label": "Liechtenstein", "value": "423" },
  { "label": "Gibraltar", "value": "350" },
  { "label": "Portugal", "value": "351" },
  { "label": "Luxembourg", "value": "352" },
  { "label": "Ireland", "value": "353" },
  { "label": "Island", "value": "354" },
  { "label": "Albania", "value": "355" },
  { "label": "Malta", "value": "356" },
  { "label": "Cyprus", "value": "357" },
  { "label": "Finland", "value": "358" },
  { "label": "Bulgaria", "value": "359" },
  { "label": "Lithuania", "value": "370" },
  { "label": "Latvia", "value": "371" },
  { "label": "Estonia", "value": "372" },
  { "label": "Moldova", "value": "373" },
  { "label": "Belarus", "value": "375" },
  { "label": "Andorra", "value": "376" },
  { "label": "Monaco", "value": "377" },
  { "label": "San Marino", "value": "378" },
  { "label": "Serbia", "value": "381" },
  { "label": "Montenegro", "value": "382" },
  { "label": "Bosnia and Herzegovina", "value": "387" },
  { "label": "Macedonia", "value": "389" },
  { "label": "Russia", "value": "7" },
  { "label": "Greece", "value": "30" },
  { "label": "Belgium", "value": "32" },
  { "label": "France", "value": "33" },
  { "label": "Spain", "value": "34" },
  { "label": "Vatican City", "value": "39" },
  { "label": "Romania", "value": "40" },
  { "label": "Switzerland", "value": "41" },
  { "label": "Denmark", "value": "45" },
  { "label": "Sweden", "value": "46" },
  { "label": "Norway", "value": "47" },
  { "label": "Turkey", "value": "90" },
  { "label": "Malaysia", "value": "60" },
  { "label": "Indonesia", "value": "62" },
  { "label": "Philippines", "value": "63" },
  { "label": "Singapore", "value": "65" },
  { "label": "Thailand", "value": "66" },
  { "label": "Brunei", "value": "673" },
  { "label": "Japan", "value": "81" },
  { "label": "Korea", "value": "82" },
  { "label": "Vietnam", "value": "84" },
  { "label": "North Korea", "value": "850" },
  { "label": "香港(Hong Kong)", "value": "852" },
  { "label": "澳门(Macao)", "value": "853" },
  { "label": "Cambodia", "value": "855" },
  { "label": "Laos", "value": "856" },
  { "label": "中国(China)", "value": "86" },
  { "label": "台湾(Taiwan)", "value": "886" },
  { "label": "Bangladesh", "value": "880" },
  { "label": "India", "value": "91" },
  { "label": "Pakistan", "value": "92" },
  { "label": "Afghanistan", "value": "93" },
  { "label": "Sri Lanka", "value": "94" },
  { "label": "Myanmar", "value": "95" },
  { "label": "Maldives", "value": "960" },
  { "label": "Lebanon", "value": "961" },
  { "label": "Jordan", "value": "962" },
  { "label": "Syria", "value": "963" },
  { "label": "Iraq", "value": "964" },
  { "label": "Kuwait", "value": "965" },
  { "label": "Saudi Arabia", "value": "966" },
  { "label": "Oman", "value": "968" },
  { "label": "Israel", "value": "972" },
  { "label": "Bahrain", "value": "973" },
  { "label": "Qatar", "value": "974" },
  { "label": "Bhutan", "value": "975" },
  { "label": "Mongolia", "value": "976" },
  { "label": "Nepal", "value": "977" },
  { "label": "Iran", "value": "98" },
  { "label": "Gibraltar", "value": "350" },
  { "label": "San Marino", "value": "223" },
  { "label": "Vatican", "value": "396" },
  { "label": "Liechtenstein", "value": "4175" },
  { "label": "Hungary", "value": "336" },
  { "label": "Germany", "value": "349" },
  { "label": "Yugoslavia", "value": "338" },
  { "label": "United States", "value": "1" },
  { "label": "Canada", "value": "1" },
  { "label": "Midway Island", "value": "1808" },
  { "label": "Hawaii", "value": "1808" },
  { "label": "Anguilla Island", "value": "1809" },
  { "label": "Alaska", "value": "1907" },
  { "label": "Greenland", "value": "299" },
  { "label": "Falkland Islands", "value": "500" },
  { "label": "Belize", "value": "501" },
  { "label": "Guatemala", "value": "502" },
  { "label": "El Salvador", "value": "503" },
  { "label": "Honduras", "value": "504" },
  { "label": "Nicaragua", "value": "505" },
  { "label": "Costa Rica", "value": "506" },
  { "label": "Panama", "value": "507" },
  { "label": "Haiti", "value": "509" },
  { "label": "Mexico", "value": "52" },
  { "label": "Cuba", "value": "53" },
  { "label": "Argentina", "value": "54" },
  { "label": "Brazil", "value": "55" },
  { "label": "Chile", "value": "56" },
  { "label": "Colombia", "value": "57" },
  { "label": "Venezuela", "value": "58" },
  { "label": "Bolivia", "value": "591" },
  { "label": "Guyana", "value": "592" },
  { "label": "Ecuador", "value": "593" },
  { "label": "French Guiana", "value": "594" },
  { "label": "Paraguay", "value": "595" },
  { "label": "Martinique", "value": "596" },
  { "label": "Suriname", "value": "597" },
  { "label": "Uruguay", "value": "598" },
  { "label": "Australia", "value": "61" },
  { "label": "New Zealand", "value": "64" },
  { "label": "Guam", "value": "671" },
  { "label": "Cocos Island", "value": "6722" },
  { "label": "Fiji", "value": "679" }
]

export default code
